"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarWalletIcon = void 0;
var React = __importStar(require("react"));
require("./StarWalletIcon.css");
var StarWalletIcon = function () { return (React.createElement("div", { className: "StarWalletIcon" },
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "82", height: "75", viewBox: "-10 0 115.6 97.6" },
        React.createElement("path", { d: "M93.8,72.8v14c0,4.9-3.4,9-7.5,9h-77c-4.1,0-7.5-4-7.5-9" }),
        React.createElement("path", { d: "M93.8,29.2V9.4c0-4.2-3.4-7.6-7.6-7.6H9.4c-4.2,0-7.6,3.4-7.6,7.6v76.4c0-2.3,2.1-4.8,6.1-4.8\n        c6.6,0,58.1,0,78.3,0c4.2,0,7.6-3.4,7.6-7.6V51.9" }),
        React.createElement("path", { d: "M48,20.5l4.6,9.3c0.4,0.9,1.3,1.5,2.3,1.7l10.3,1.5c2.5,0.4,3.5,3.4,1.7,5.2l-7.4,7.2c-0.7,0.7-1,1.7-0.9,2.7\n        l1.8,10.2c0.4,2.5-2.2,4.4-4.4,3.2l-9.2-4.8c-0.9-0.5-1.9-0.5-2.8,0l-9.2,4.8c-2.2,1.2-4.8-0.7-4.4-3.2L32,48c0.2-1-0.2-2-0.9-2.7\n        l-7.4-7.2c-1.8-1.8-0.8-4.8,1.7-5.2l10.3-1.5c1-0.1,1.8-0.8,2.3-1.7l4.6-9.3C43.7,18.2,46.9,18.2,48,20.5z" }),
        React.createElement("path", { d: "M100,50.8H86.8c-1.4,0-2.6-0.8-3.3-2l-3.3-6.2c-0.6-1.1-0.6-2.5,0-3.7l3.3-6.2c0.7-1.2,1.9-2,3.3-2H100\n        c2.1,0,3.8,1.7,3.8,3.8V47C103.8,49.1,102.1,50.8,100,50.8z" })))); };
exports.StarWalletIcon = StarWalletIcon;
